import { render, staticRenderFns } from "./RecipeDetails.vue?vue&type=template&id=6035574d&scoped=true&"
import script from "./RecipeDetails.vue?vue&type=script&lang=js&"
export * from "./RecipeDetails.vue?vue&type=script&lang=js&"
import style0 from "./RecipeDetails.vue?vue&type=style&index=0&id=6035574d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035574d",
  null
  
)

export default component.exports